
















































































import {
  Component,
  Vue,
} from 'vue-property-decorator';

import bButton from 'bootstrap-vue/es/components/button/button';
import bLink from 'bootstrap-vue/es/components/link/link';

import { ProductVariant } from '@/models';

import PriceBlock from '@/components/PriceBlock.vue';

const CartProps = Vue.extend({
  props: {
    // FIXME: Should be line items.
    variants: {
      type: Array as () => ProductVariant[],
      required: true,
    },
  },
});

@Component({
  components: {
    PriceBlock,
    bButton,
    bLink,
  },
})
export default class Cart extends CartProps { }

